import { t } from 'i18next';
import { X } from 'lucide-react';

import { LeftSideBarType, useBuilderStateContext } from '../builder-hooks';

import { GenerateFlow } from './generate-flow';

import { Button } from '@/components/ui/button';

export const AiBuilderSidebar = () => {
  const [setLeftSidebar] = useBuilderStateContext((state) => [
    state.setLeftSidebar,
  ]);

  return (
    <div className="max-w-4xl mx-auto h-full flex flex-col">
      <div className="flex px-2 pb-2 w-full gap-2 text-lg font-semibold items-center">
        {t('AI Builder')}
        <div className="grow" />
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setLeftSidebar(LeftSideBarType.NONE)}
          aria-label={t('Close')}
        >
          <X size={16} />
        </Button>
      </div>

      <div className="bg-white shadow flex-1 overflow-auto">
        <GenerateFlow />
      </div>
    </div>
  );
};
